<template>
  <div>
    <!-- header -->
    <Header></Header>

    <div class="sub-wrapper">
      <div class="title-bg consulting">
        <div class="container inner">
          <p>진단 및 컨설팅</p>
          <p>
            말하기 역량, 글로벌역량진단, 리더십 및 조직개발을 위한<br />진단을
            실시하고, 맞춤형 교육 컨설팅을 진행해 드립니다.
          </p>
          <p class="pointer" @click="goInquiry">교육 문의하기</p>
        </div>
      </div>
      <ul class="pdf-wrapper">
        <li id="content00">
          <div class="container inner">
            <div class="img-wrapper">
              <img
                src="@/assets/img/newGlobal/sub/consulting/00.png"
                alt="img"
              />
            </div>
            <div class="text-wrapper">
              <p>외국어 능력평가 (SPAC^)</p>
              <div class="line"></div>
              <p>
                핵심인재 국제 감각 양성, 신뢰도 높은 산업별 데이터로 교육 전후
                효과성 분석에 탁월한 최적의 어학 평가 솔루션입니다.
              </p>
              <ul>
                <li>
                  정확한 스피킹 실력평가가 가능한 기업/단체 전용 시험으로
                  교육대상자 선정 및 성과 측정, 신입사원선발, 해외주재원 선발
                  등에 적합
                </li>
                <li>
                  15분간 평가 시간이 소요되며, 언제, 어디서나 모바일로 응시
                  가능한 편리성 보유
                </li>
                <li>
                  250,000여건 기업/산업별 데이터 분석자료 제공, 전문 rater의
                  영역별 평가 및 종합 첨삭 코멘트 제공
                </li>
              </ul>
              <div class="down-wrapper">
                <a @click="showImgView(list[0])" target="_blank"
                  >상세과정 보기</a
                >
              </div>
            </div>
          </div>
        </li>
        <li id="content01">
          <div class="container inner">
            <div class="img-wrapper">
              <img
                src="@/assets/img/newGlobal/sub/consulting/01.png"
                alt="img"
              />
            </div>
            <div class="text-wrapper">
              <p>
                gCAT Global Competency Assessment Tool<br />(gCAT 글로벌
                역량진단 평가)
              </p>
              <div class="line"></div>
              <p>
                자사의 글로벌 역량을 선별하고 훈련 프로그램 구성의 기준을
                제시합니다. 이를 통해 해외 파견 예정자 및 예비 인재, 임직원의
                글로벌 역량강화 종합 솔루션을 제공합니다.
              </p>
              <ul>
                <li>
                  글로벌 역량강화의 기준(Standard) 제공
                  <ul>
                    <li>
                      글로벌역량을 진단하고 훈련 프로그램 구성의 기준을
                      제시합니다.
                    </li>
                    <li>
                      해외파견 예정자 및 예비 인재의 교육 가이드를 제공합니다.
                    </li>
                  </ul>
                </li>
                <li>
                  글로벌 인재 풀(pool)의 확보 및 관리
                  <ul>
                    <li>
                      해외주재원 등 현지 파견 대상자 선발 시 도움을 드립니다.
                    </li>
                  </ul>
                </li>
                <li>선발 / 파견 인원에 대한 지속적 교육 / 관리 가능</li>
                <li>
                  교육 영역 도출 목적의 자가진단(DC)과 선발 목적의 평가(AC) 버전
                  제공
                </li>
              </ul>
              <div class="down-wrapper">
                <a @click="showImgView(list[1])" target="_blank"
                  >상세과정 보기</a
                >
              </div>
            </div>
          </div>
        </li>
        <li id="content02">
          <div class="container inner">
            <div class="img-wrapper">
              <img
                src="@/assets/img/newGlobal/sub/consulting/02.png"
                alt="img"
              />
            </div>
            <div class="text-wrapper">
              <p>리더십 역량 진단 (SLCC)</p>
              <div class="line"></div>
              <p>
                CCL 연구 결과 기반으로 성공하는 리더가 공통적으로 지닌 주요
                역량을 분석하여 진단 역량 별 행동 가이드과 교육을 제공합니다.
              </p>
              <ul>
                <li>
                  내가 보는 나, 타인이 보는 나에 대한 객관적 분석을 통해
                  리더십을 진단하고 교육 기획을 설계하는 목적의 진단
                </li>
                <li>
                  자기인식, 학습민첩성, 영향력, 소통 등 CCL 기반의 4가지 요소를
                  진단, 360도 다면 평가
                </li>
                <li>
                  직무 및 산업군 별 리더십 그룹 리포트 제공 가능, 리더십 보완
                  요인 도출로 맞춤 교육 기획 설계 가능. 보완 요인별 강화 워크숍
                  및 코칭 진행
                </li>
              </ul>
              <div class="down-wrapper">
                <a @click="showImgView(list[2])" target="_blank"
                  >상세과정 보기</a
                >
              </div>
            </div>
          </div>
        </li>
        <li id="content03">
          <div class="container inner">
            <div class="img-wrapper">
              <img
                src="@/assets/img/newGlobal/sub/consulting/03.png"
                alt="img"
              />
            </div>
            <div class="text-wrapper">
              <p>조직 마음 건강 진단 (MSS)</p>
              <div class="line"></div>
              <p>
                조직 구성원들의 5대 마음건강 영역을 진단하여 조직과 개인에
                과학적 맞춤 솔루션을 제공합니다.
              </p>
              <ul>
                <li>
                  스트레스가 많은 직군 혹은 불확실성이 큰 직군 직원들의 정신건강
                  상태 파악하고 조직의 성장 도모하기 위한 개입 방안 모색 가능
                </li>
                <li>
                  5가지 정신건강 요인 (회복탄력성, 탈진, 분노관리, 직무만족도,
                  삶의 만족도) 측정
                </li>
                <li>
                  총 95개 문항을 30분 내 온라인으로 응시 완료 가능하며 체계적인
                  개인별 보고서 제공
                </li>
              </ul>
              <div class="down-wrapper">
                <a @click="showImgView(list[3])" target="_blank"
                  >상세과정 보기</a
                >
              </div>
            </div>
          </div>
        </li>
        <li id="content04">
          <div class="container inner">
            <div class="img-wrapper">
              <img
                src="@/assets/img/newGlobal/sub/consulting/04.png"
                alt="img"
              />
            </div>
            <div class="text-wrapper">
              <p>성격유형 검사 (에니어그램)</p>
              <div class="line"></div>
              <p>
                에니어그램 검사는 사람을 9가지 성격으로 분류하는 성격 유형
                지표이자 인간을 이해하는 유용한 검사로, 임직원의 기본 성향과
                기질에 따른 업무 스타일, 적합한 직무배치, 갈등 등을 이해하는데
                도움이 되는 검사입니다.
              </p>
              <ul>
                <li>
                  자신의 성격을 이해하고 변화를 추구, 타인의 성격 유형을
                  이해함으로써 인간관계의 갈등을 해소하여 리더십 과정이나 팀빌딩
                  향상 과정에 적합
                </li>
                <li>
                  내 유형 특성 키워드, 심리적 배경, 내 유형의 삶의 방식 이해 및
                  가장 성숙한 상태의 나, 변화와 성장을 위한 조언 포함
                </li>
                <li>
                  30분간 온라인 검사 가능, 총 144개 문항을 바탕으로 유형별
                  역량과 가치를 이해하는 진단과 이를 바탕으로 한 사후 워크숍
                  과정으로 구성
                </li>
              </ul>
              <div class="down-wrapper">
                <a @click="showImgView(list[4])" target="_blank"
                  >상세과정 보기</a
                >
              </div>
            </div>
          </div>
        </li>
        <li id="content05">
          <div class="container inner">
            <div class="img-wrapper">
              <img
                src="@/assets/img/newGlobal/sub/consulting/05.png"
                alt="img"
              />
            </div>
            <div class="text-wrapper">
              <p>
                Program & Contents Customization<br />(고객사 맞춤 과정 및
                컨텐츠 개발)
              </p>
              <div class="line"></div>
              <p>
                캐럿글로벌 R&D센터를 통한 고객사별 직무/기술 맞춤 컨텐츠를
                개발,<br />실제 업무에 반영하고, 자사만의 주요 내용을 직원분들께
                효과적으로 제공할 수 있습니다.
              </p>
              <ul>
                <li>
                  스마트 러닝 / 현장 매뉴얼 고도화 / 글로벌 역량체계 수립 컨설팅
                </li>
                <li>
                  회사 소개, 핵심 가치부터 직무 회화, 매뉴얼, 이문화 맞춤
                  영상까지 고객의 니즈 맞춤 100% 제작 컨텐츠 제공
                </li>
              </ul>
              <div class="down-wrapper">
                <a @click="showImgView(list[5])" target="_blank"
                  >상세과정 보기</a
                >
              </div>
            </div>
          </div>
        </li>
      </ul>

      <!-- 문의하기 -->
      <div class="inquiry-container">
        <Inquiry></Inquiry>
      </div>
    </div>

    <!-- footer -->
    <Footer> </Footer>

    <!-- 이미지 뷰 모달 -->
    <ImageView
      v-if="isimgViewVisible"
      @closeImgView="hideImgView"
      :imgP="imageData.imgP"
      :imgM="imageData.imgM"
    ></ImageView>
  </div>
</template>
<script>
import Header from "@/components/NewGlobal/Header.vue";
import Footer from "@/components/NewGlobal/Footer.vue";
import Inquiry from "@/components/NewGlobal/Inquiry.vue";
import ImageView from "@/page/NewGlobal/ImageView.vue";
import "@/assets/style/newGlobalReset.scss";
import "@/assets/style/newGlobalSub.scss";

export default {
  name: "consulting",
  components: {
    Header,
    Footer,
    Inquiry,
    ImageView,
  },
  mounted() {
    // global header
    // const header = document.querySelector("#header");
    // header.style.display = "none";

    // main header color
    const mainHeader = document.querySelector(".header");
    const introWrapper = document.querySelector(".title-bg").offsetHeight;

    window.addEventListener("scroll", function () {
      if (window.scrollY >= introWrapper) {
        mainHeader.classList.add("active");
      } else {
        mainHeader.classList.remove("active");
      }
    });

    // main mobile nav
    const mtMenu = document.querySelector(".mt-nav");

    const openMenu = document.querySelector(".open-menu");
    openMenu.addEventListener("click", function () {
      mtMenu.style.display = "block";
    });

    const closeMenu = document.querySelector(".close-menu");
    closeMenu.addEventListener("click", function () {
      mtMenu.style.display = "none";
    });

    window.addEventListener("DOMContentLoaded", function () {
      if (screen.width > 1200) {
        mtMenu.style.display = "none";
      }
    });

    window.addEventListener("resize", function () {
      if (screen.width > 1200) {
        mtMenu.style.display = "none";
      }
    });
  },
  data() {
    return {
      list: [
        {
          imgM: "https://kr.object.ncloudstorage.com/newglobal/sub/consulting/01_%EB%AA%A8%EB%B0%94%EC%9D%BC.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/sub/consulting/01_pc.jpg",
        },
        {
          imgM: "https://kr.object.ncloudstorage.com/newglobal/sub/consulting/02_%EB%AA%A8%EB%B0%94%EC%9D%BC.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/sub/consulting/02_pc.jpg",
        },
        {
          imgM: "https://kr.object.ncloudstorage.com/newglobal/sub/consulting/03_%EB%AA%A8%EB%B0%94%EC%9D%BC.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/sub/consulting/03_pc.jpg",
        },
        {
          imgM: "https://kr.object.ncloudstorage.com/newglobal/sub/consulting/04_%EB%AA%A8%EB%B0%94%EC%9D%BC.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/sub/consulting/04_pc.jpg",
        },
        {
          imgM: "https://kr.object.ncloudstorage.com/newglobal/sub/consulting/05_%EB%AA%A8%EB%B0%94%EC%9D%BC.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/sub/consulting/05_pc.jpg",
        },
        {
          imgM: "https://kr.object.ncloudstorage.com/newglobal/sub/consulting/06_%EB%AA%A8%EB%B0%94%EC%9D%BC.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/sub/consulting/06_pc.jpg",
        },
      ],

      isimgViewVisible: false,
    };
  },
  methods: {
    goInquiry() {
      document
        .getElementById("inqueryTxtArea")
        .scrollIntoView({ behavior: "smooth", block: "center" });
    },

    showImgView(item) {
      this.isimgViewVisible = true;
      this.imageData = {
        imgP: item.imgP,
        imgM: item.imgM,
      };
    },

    hideImgView() {
      this.isimgViewVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped></style>
